export default __webpack_public_path__ + "static/media/speaker34.42eab823.png";